import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
} from '@fortawesome/free-solid-svg-icons';
import {faVideo} from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class AboutPart extends React.Component {

    render() { 
      const {t} = this.props
        return ( 
            <React.Fragment>
{
  /*====== ABOUT PART START ======*/
}
<div className="about-area pt-90 pb-120">
  <Container>
    <Row className="align-items-center">
      <Col lg="6" md="12" className="order-2 order-lg-1">
        <div className="about-thumb mt-30">
          <img src="/assets/images/about-thumb.jpg" alt="" />
        </div>
        {/* about thumb */}
      </Col>
      <Col lg="6" md="12" className="order-1 order-lg-2">
        <div className="about-item mt-30">
          <span>{t('about-part')}</span>
          <h3 className="title">{t('about-part.title')}</h3>
          <p>
          {t('about-part.desc1')}
          </p>
          <div className="about-experience">
            <h3>10</h3>
            <span>
            {t('about-part.experience1')} <br /> {t('about-part.experience2')}
            </span>
          </div>
          <ul>
            <li>
              <Link
                className="main-btn wow fadeInUp"
                data-wow-duration="1s"
                data-wow-delay=".1s"
                to={"about"}
              >
                {t('about-part.learn-more')}
              </Link>
            </li>
            <li>
              <Link
                className="main-btn main-btn-2 wow fadeInUp"
                data-wow-duration="2s"
                data-wow-delay=".5s"
                to={"/"}
              >
                <FontAwesomeIcon icon={faVideo} className={`pr-1`}/>

                {t('about-part.intro-video')}
              </Link>
            </li>
          </ul>
        </div>
        {/* about item */}
      </Col>
    </Row>
    {/* row */}
  </Container>
  {/* container */}
</div>;
{
  /*====== ABOUT PART ENDS ======*/
}

            </React.Fragment>
         );
    }
}
 
export default withTranslation('translation')(AboutPart);